export const bookingAffirmations = {
  serviceSelection: [
    "Great choice! That service is perfect.",
    "Excellent selection! You're going to love it.",
    "Perfect pick! We're excited to serve you.",
    "Awesome choice! You've selected one of our most popular services."
  ],
  dateSelection: [
    "Date confirmed! Looking forward to seeing you.",
    "Great timing! We've got you on the calendar.",
    "Perfect! We'll see you then.",
    "Date secured! We can't wait to see you."
  ],
  timeSelection: [
    "Time locked in! We'll be ready for you.",
    "Perfect timing! See you then.",
    "Time confirmed! Looking forward to it.",
    "Great choice of time! We'll be prepared for your arrival."
  ],
  infoComplete: [
    "Details saved! Thanks for providing your information.",
    "Perfect! Your contact details have been saved.",
    "Information received! We'll use this to contact you about your booking.",
    "Details confirmed! You're all set."
  ],
  paymentComplete: [
    "Payment successful! Your appointment is confirmed.",
    "Thank you for your payment! Your spot is secured.",
    "Payment received! We'll see you at your appointment.",
    "Transaction complete! Your booking is confirmed."
  ],
  providerSelection: [
    "Great choice! You've selected an excellent provider.",
    "Perfect! Your provider is confirmed.",
    "Excellent selection! This provider is fantastic.",
    "Provider confirmed! You're in good hands."
  ]
};

export const getRandomAffirmation = (type: keyof typeof bookingAffirmations): string => {
  const affirmations = bookingAffirmations[type];
  const randomIndex = Math.floor(Math.random() * affirmations.length);
  return affirmations[randomIndex];
};
